import React, { useState } from 'react';

import Skeleton from '@material-ui/lab/Skeleton';
import { searchAutoCompleteV2Api } from 'api/search';
import { StyledAvatar } from 'components/avatars';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { SearchIcon } from 'constants/icons';

const Control = ({ children, ...rest }) => (
  <components.Control {...rest}>
    <SearchIcon size="tiny" style={{ marginRight: '5px' }} />
    {children}
  </components.Control>
);

const SearchSelect = styled(AsyncSelect)`
  width: 100%;
  display: inline-block;
  font-size: 20px;

  .react-select-custom__control {
    padding: 5px 24px !important;
  }
  .react-select-custom__indicators {
    display: none;
  }
  .react-select-custom__placeholder {
    color: #999999;
    font-size: 20px;
  }
  .react-select-custom__group {
    .react-select-custom__option {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &:first-child {
      .react-select-custom__group-heading {
        display: none;
      }
    }
    &:last-child {
      .react-select-custom__option {
        &:last-child {
          border: none;
        }
      }
    }
  }
  ${(props) => props.theme.breakpoints.up('sm')} {
    .react-select-custom__control {
      border: 1px solid ${(props) => props.theme.palette.borders.lightGrey};
      padding: 0.5rem 0.7rem;
    }
  }
  .react-select-custom__option--is-disabled {
    cursor: initial;
    &:hover {
      background: none;
    }
  }
`;

const StyledAvatar1 = styled(StyledAvatar)`
  display: inline-block;
  vertical-align: middle;
  height: 34px;
  width: 34px;
  margin-right: 10px;
`;

const CircleSkeleton = styled(Skeleton)`
  display: inline-block;
`;

const RectSkeleton = styled(CircleSkeleton)`
  display: inline-block;
  vertical-align: super;
  margin-left: 1rem;
`;
const SearchEmployees = ({ exclusions = [], onSelect }) => {
  const [searchText, setSearchText] = useState('');

  const selectStyles = {
    option: (provided, { imageUrl }) => ({
      ...provided,
      cursor: 'pointer',
      padding: imageUrl ? '10px 14px' : '14px',
      fontWeight: 500,
      '&:hover': {
        background: 'rgba(230, 236, 240, 0.4)',
      },
    }),
    loadingMessage: (provided) => ({
      ...provided,
      padding: '1em 14px',
      textAlign: 'left',
    }),
  };

  const NoOptionsMessage = (props) => (
    <components.NoOptionsMessage {...props}>
      {searchText ? 'No results found' : 'Try searching for employees'}
    </components.NoOptionsMessage>
  );

  const Option = (props) => {
    const { data } = props;
    return (
      <components.Option {...props} imageUrl={data.imageUrl}>
        {data.imageUrl && <StyledAvatar1 display="inline" size="icon" src={data.imageUrl} />}
        <StyledTypography display="inline" variant="body1">
          {data.label}
        </StyledTypography>
      </components.Option>
    );
  };

  const LoadingMessage = (props) => (
    <components.LoadingMessage {...props}>
      <>
        <div>
          <CircleSkeleton variant="circle" width={34} height={34} />
          <RectSkeleton variant="rect" width={180} height={22} />
        </div>
        <div>
          <CircleSkeleton variant="circle" width={34} height={34} />
          <RectSkeleton variant="rect" width={225} height={22} />
        </div>
      </>
    </components.LoadingMessage>
  );

  const handleInputChange = (value) => setSearchText(value);

  const loadOptions = async (text, callback) => {
    const res = await searchAutoCompleteV2Api({
      moduleType: null,
      searchText: text,
      offset: 0,
      employeeIds: [...exclusions],

      limit: 5,
    });

    const data = res.entity
      .map((entry) => {
        const curEmployee = {
          uuid: entry.id,
          metadata: {
            displayName: entry.displayName,
            email: entry.email,
            designation: entry.designation,
            employeeFunction: entry.employeeFunction,
          },
          profile: {
            profilePhoto: entry.profilePhoto,
          },
          ownerType: entry.ownerType,
        };
        const { uuid, metadata, profile } = curEmployee;
        const numberUuid = parseInt(uuid);
        const isDisabled = exclusions?.includes(numberUuid);
        if (exclusions?.includes(uuid)) {
          return null;
        }
        return {
          displayName: metadata.displayName,
          filterTagType: 'EMPLOYEE_NAME',
          imageUrl: profile.profilePhoto,
          uuid,
          value: uuid,
          label: metadata.displayName,
          id: uuid,
          email: metadata.email,
          isDisabled, // Set the isDisabled property
        };
      })
      ?.filter((item) => item !== null);

    return data;
  };

  const handleChange = (option) => {
    const employee = {
      id: Number(option.id),
      displayName: option.label,
      profilePhoto: option.imageUrl,
    };
    onSelect(employee);
    setSearchText('');
  };

  return (
    <SearchSelect
      placeholder="Search to add an employee"
      components={{ LoadingMessage, NoOptionsMessage, Option, Control }}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      classNamePrefix="react-select-custom"
      onChange={handleChange}
      menuPlacement="auto"
      value={searchText}
      styles={selectStyles}
    />
  );
};

export default SearchEmployees;
